/* Customea homepage - quote carousel.
   Loaded only by sections/customea-featured-review.liquid.
   Progressive enhancement: with this file absent or JS off, CSS shows the first
   quote and keeps the controls hidden. */
(function () {
  'use strict';

  function initCarousel(root) {
    if (root.dataset.chQuotesReady === 'true') return;

    var items = Array.prototype.slice.call(root.querySelectorAll('[data-ch-quote]'));
    var dots = Array.prototype.slice.call(root.querySelectorAll('[data-ch-dot]'));
    var prev = root.querySelector('[data-ch-prev]');
    var next = root.querySelector('[data-ch-next]');
    if (items.length < 2) return;

    root.dataset.chQuotesReady = 'true';
    root.classList.add('ch-quotes--js');

    var index = 0;

    function show(nextIndex) {
      var total = items.length;
      index = ((nextIndex % total) + total) % total;

      items.forEach(function (item, i) {
        var active = i === index;
        item.classList.toggle('is-active', active);
        if (active) {
          item.removeAttribute('aria-hidden');
        } else {
          item.setAttribute('aria-hidden', 'true');
        }
      });

      dots.forEach(function (dot, i) {
        var active = i === index;
        dot.classList.toggle('is-active', active);
        if (active) {
          dot.setAttribute('aria-current', 'true');
        } else {
          dot.removeAttribute('aria-current');
        }
      });
    }

    if (prev) {
      prev.addEventListener('click', function () {
        show(index - 1);
      });
    }
    if (next) {
      next.addEventListener('click', function () {
        show(index + 1);
      });
    }

    dots.forEach(function (dot) {
      dot.addEventListener('click', function () {
        show(parseInt(dot.getAttribute('data-ch-dot'), 10) || 0);
      });
    });

    root.addEventListener('keydown', function (event) {
      if (event.key === 'ArrowLeft') {
        event.preventDefault();
        show(index - 1);
      } else if (event.key === 'ArrowRight') {
        event.preventDefault();
        show(index + 1);
      }
    });

    show(0);
  }

  function initAll(scope) {
    var roots = (scope || document).querySelectorAll('[data-ch-quotes]');
    Array.prototype.forEach.call(roots, initCarousel);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initAll(document);
    });
  } else {
    initAll(document);
  }

  /* Theme editor: re-init when the section is re-rendered or a block is added. */
  document.addEventListener('shopify:section:load', function (event) {
    initAll(event.target);
  });
  document.addEventListener('shopify:block:select', function (event) {
    var root = event.target.closest ? event.target.closest('[data-ch-quotes]') : null;
    if (!root) return;
    var item = event.target.closest('[data-ch-quote]');
    if (!item) return;
    var items = Array.prototype.slice.call(root.querySelectorAll('[data-ch-quote]'));
    var dot = root.querySelectorAll('[data-ch-dot]')[items.indexOf(item)];
    if (dot) dot.click();
  });
})();
